import { render, staticRenderFns } from "./LiveComment.vue?vue&type=template&id=58015172"
import script from "./LiveComment.vue?vue&type=script&lang=js"
export * from "./LiveComment.vue?vue&type=script&lang=js"
import style0 from "./LiveComment.vue?vue&type=style&index=0&id=58015172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports